module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-image-2-4a8bc75ce1f75fd9133ce663aacd2fc1.jpg";